import script from "./BackPrePage.vue?vue&type=script&setup=true&lang=js"
export * from "./BackPrePage.vue?vue&type=script&setup=true&lang=js"

import "./BackPrePage.vue?vue&type=style&index=0&id=771e517e&scoped=true&lang=scss"

import exportComponent from "D:\\work\\project\\week-alone\\weekly-alone-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-771e517e"]])

export default __exports__